import {
  ADD_JOB_FAILED,
  CONFIRMED_GET_ALL_JOBS,
  CONFIRMED_GET_JOBS,
  CONFIRMED_GET_SINGLE_JOBS,
  GET_JOBS_FAILED_ACTION,
} from "../../actions/Jobs/jobTypes";

const initialState = {
  jobList: [],
  allJobList: [],
  selectedRequirement: {},
  errorMessage: "",
  successMessage: "",
  showLoading: false,
};

export function JobReducer(state = initialState, action) {
  switch (action.type) {
    case CONFIRMED_GET_ALL_JOBS:
      return {
        ...state,
        allJobList: action.payload,
        successMessage: "",
        errorMessage: "",
        showLoading: false,
      };
      
    case CONFIRMED_GET_SINGLE_JOBS:
      return {
        ...state,
        selectedRequirement: action.payload,
        successMessage: "",
        errorMessage: "",
        showLoading: false,
      };

    case CONFIRMED_GET_JOBS:
      return {
        ...state,
        jobList: action.payload,
        showLoading: false,
      };

    case GET_JOBS_FAILED_ACTION:
    case ADD_JOB_FAILED:
      return {
        ...state,
        errorMessage: action.payload,
        successMessage: "",
        showLoading: false,
      };

    default:
      return state;
  }
}
